<template>
  <!--页面加载动画-->
  <div class="email-box">
    <input
      type="input"
      class="input-text"
      :value="value"
      @blur="handle"
      @focus="focus"
      @input="change"
      placeholder="请输入"
    />
    <i class="iconfont iconfabiaowenzhang"></i>
    <div class="email-pop-box" v-show="showSuffix">
      <template v-for="(item, i) in slotsData">
        <div class="email-li" @click="checkLi(i)" v-if="item.show">{{item.value?defaultTxt+item.value:"请选择邮箱后缀，或自行输入！"}}</div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: "",//默认值
      defaultTxt: "",//去后缀结果
      suffix:'@163.com',//当前邮箱后缀
      showSuffix:false,//显示选择后缀
      slotsData:[],//后缀数据
      allEmails:["@qq.com", "@sina.com", "@126.com", "@163.com", "@139.com", "@189.cn", "@sohu.com", "@gmail.com", "@yahoo.com", "@msn.com", "@hotmail.com", "@21cn.com", "@live.com", "@yeah.net"],
    };
  },
  props: ["selectData"],
  mounted() {
    this.initEmails();
      if(this.selectData.elementValue){
        this.value=this.selectData.elementValue
      }
  },
  methods: {
    initEmails(){
      let data=[{show:true,value:""}];
      this.allEmails.forEach(item=>{
        data.push({
          show:true,
          value:item
        })
      })
      this.slotsData=data;
    },
    change(e){
      console.log(e);
      let value=e.target.value;
      this.value=value;
      this.checkSuffix(value)
    },
    // 匹配后缀
    checkSuffix(value){
      if(value.indexOf("@")>-1){
        this.defaultTxt=value.split("@")[0];
        let slot=value.split("@")[1];
        let noMatch=true;
        this.slotsData.forEach(item=>{
          if(item.value.indexOf(slot)==-1){
            item.show=false
          }else{
            item.show=true
            noMatch=false
          }
        })
        if(noMatch){
          this.showSuffix=false;
        }else{
          this.showSuffix=true;
        }
      }else{
        this.defaultTxt=value;
        this.showSuffix=true;
        this.slotsData.forEach(item=>{
          item.show=true
        })
      }
    },
    focus(){
      this.checkSuffix(this.value)
    },
    handle(e) {
      //输入框失焦回调
      setTimeout(()=>{
        this.showSuffix=false;
        this.getResult();
      },200)
    },
    // 邮箱列表选择
    checkLi(i){
      if(i==0)return;
      console.log(i);
      this.value = this.defaultTxt+this.slotsData[i].value;
    },
    getResult() {
      //选择后回调到父组件
      let value = this.value;
      if(!this.$regulars.isEmail(value)){
        this.selectData.errorMsg="您填写的不是合格的邮箱！";
        return
      };
      this.selectData.errorMsg="";
      this.selectData.elementValue=value;
      this.$emit("selected", {
        type:1,
        item:this.selectData,
        value: value
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.email-box{
  width: 100%;
  display: block;
  position: relative;
  .input-text{
    width: 100%;
    height: 60px;
  }
  .iconfont {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  color: #0084ff;
  font-size: 36px;
  opacity: 0.7;
}
  .email-pop-box{
    position: absolute;
    right: 0;
    top:60px;
    z-index: 99;
    width:120%;
    height: 330px;
    overflow-y: scroll;
    background-color: #fff;
    box-shadow: 0 0 5px 0 rgba($color: #000, $alpha: 0.3);
    padding: 5px;
    .email-li{
      text-align: right;
      width: 100%;
      font-size: 28px;
      color: #666;
    }
  }
  
}

</style>